import React, { useContext, useEffect, useState } from 'react'
import { VehicleContext } from '../Context/VehicleContext';
import ModalLayout from '../Common/ModalLayout';
import { getImages } from '../Common/const';
import AdminModalLayout from './AdminCommon/AdminModalLayout';
import AddVehicle from './AddVehicle';

const ManageVehicles = () => {
    const { getVehicleData, vehicleData, searchText, setSearchText, priceFormatter, inventoryManage, removeInventoryVehicle } = useContext(VehicleContext);
    const handleSearchChange = (e) => {
        setSearchText(e.target.value.toLowerCase());
    };

    useEffect(() => {
        getVehicleData();
    }, []);

    const [openAddVehicle, setOpenAddVehicle] = useState(false);
    const handleAddVehicle = () => {
        setOpenAddVehicle(true);
        document.body.classList.add('body-overflow');
    }
    const closeAddVehicle = () => {
        setOpenAddVehicle(false);
        document.body.classList.remove('body-overflow');
    }

    const [selectedVehicle,setSelectedVehicle] = useState([]);

    const [inventoryManageData,setInventoryManageData] = useState({});

    useEffect(() => {
        if(vehicleData) {
            const inventory_manage_data = vehicleData.reduce((acc, item) => {
                acc[item.vin] = item.inventory_manage; // Or acc[key] = item; if you want the whole item
                return acc;
            }, {});
            console.log(inventory_manage_data);
            setInventoryManageData(inventory_manage_data);
        }
    },[vehicleData]);

    const updateInventoryManage = (e,vin,field) => {

        console.log();

        setInventoryManageData((prev) => ({
            ...prev,
            [vin] : {...prev[vin],[field]:e.target.checked}
        }));

        inventoryManage({...inventoryManageData[vin],[field]:e.target.checked,["vin"]:vin})
    }

    const deleteVehicle = (vin) => {
        console.log(vin);

        if(window.confirm("Confirm deleting "+vin)) removeInventoryVehicle(vin);
    }

    return (
        <>
            <section className='admin-common-wrap'>
                <div className='container'>
                    <div className='admin-black-box'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='md-title text-uppercase'>Manage Vehicles</div>
                            <div className='d-flex align-items-center'>
                                <div className='me-4'>
                                    <button type='button' onClick={handleAddVehicle} className='black-btn fw-500 text-uppercase admin-sm-btn'>+ &nbsp;Add Vehicle</button>
                                </div>
                                <div className='ad-search-block dash-search-block d-flex align-items-center'>
                                    <input type='text' className='form-control' placeholder='Vehicle Search' value={searchText} onChange={handleSearchChange} />
                                    <button className='dash-search-btn'>Search</button>
                                </div>
                            </div>
                        </div>
                        <div className='admin-custom-table mt-5'>
                            <table className='w-100'>
                                <tbody>
                                    <tr>
                                        <th>Photo</th>
                                        <th className='text-start'>Vehicle</th>
                                        <th>Price</th>
                                        <th>Miles</th>
                                        <th>Stock #</th>
                                        <th>Latest <br />Drop</th>
                                        <th>Featured</th>
                                        <th>Hide</th>
                                        <th>Edit</th>
                                    </tr>
                                </tbody>
                                <tbody>
                                    {vehicleData && vehicleData.map((item, index) =>
                                        <tr key={index}>
                                            <td
                                                style={{
                                                    width: '180px'
                                                }}
                                            >
                                                <div className='act-image'>
                                                    <img src={item?.images[0]} alt="" />
                                                </div>
                                            </td>
                                            <td className='text-start'>
                                                <div className='pt-2'>{item.vehicle_name}</div>
                                            </td>
                                            <td>
                                                <div className='pt-2'>{priceFormatter(item.price, true)}</div>
                                            </td>
                                            <td>
                                                <div className='pt-2'>{item.mileage.toLocaleString()}mi</div>
                                            </td>
                                            <td>
                                                <div className='pt-2'>{item.stockno}</div>
                                            </td>
                                            <td>
                                                <div className='pt-2'>
                                                    {inventoryManageData && item.vin in inventoryManageData && <div className="custom-checkbox admin-checkbox">
                                                        <input type="checkbox" id={`latestDrop${index}`} checked={inventoryManageData[item.vin].latest_drop} 
                                                            onChange={(e) => {updateInventoryManage(e,item.vin,'latest_drop')}}
                                                        />
                                                        <label className='ps-0' htmlFor={`latestDrop${index}`}>&nbsp;</label>
                                                    </div>}
                                                </div>
                                            </td>
                                            <td>
                                                <div className='pt-2'>
                                                    {inventoryManageData && item.vin in inventoryManageData && <div className="custom-checkbox admin-checkbox">
                                                        <input type="checkbox" id={`Featured${index}`} checked={inventoryManageData[item.vin].featured} 
                                                            onChange={(e) => {updateInventoryManage(e,item.vin,'featured')}}
                                                        />
                                                        <label className='ps-0' htmlFor={`Featured${index}`}>&nbsp;</label>
                                                    </div>}
                                                </div>
                                            </td>
                                            <td>
                                                <div className='pt-2'>
                                                    {inventoryManageData && item.vin in inventoryManageData && <div className="custom-checkbox admin-checkbox">
                                                        <input type="checkbox" id={`hide${index}`} checked={inventoryManageData[item.vin].hide} 
                                                            onChange={(e) => {updateInventoryManage(e,item.vin,'hide')}}
                                                        />
                                                        <label className='ps-0' htmlFor={`hide${index}`}>&nbsp;</label>
                                                    </div>}
                                                </div>
                                            </td>
                                            <td>
                                                {item.manual_entry ?
                                                <>
                                                    <button className='black-btn fw-500 text-uppercase admin-sm-btn' onClick={() => {setSelectedVehicle(item); handleAddVehicle();}}>Edit </button>
                                                    <button className='black-btn fw-500 text-uppercase admin-sm-btn' onClick={() => {deleteVehicle(item.vin);}}>Delete </button>
                                                </>
                                                    
                                                    :
                                                    <span>From Feed</span>
                                                }
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
            <AdminModalLayout open={openAddVehicle} close={closeAddVehicle} modalWidth={1000}>
                <AddVehicle  close={closeAddVehicle} handleAddVehicle={handleAddVehicle} selectedVehicle={selectedVehicle}/>
            </AdminModalLayout>
        </>
    )
}

export default ManageVehicles